import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { EmployeeContract } from './employee-contract'
import { employeeContractActions } from './employee-contract.actions'
import * as fromEmployeeContract from './employee-contract.reducer'
import { EmployeeContractService } from './employee-contract.service'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { exhaustMap, map } from 'rxjs/operators'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class EmployeeContractEffects extends ResourceEffects<EmployeeContract> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private employeeContractService: EmployeeContractService
  ) {
    super(
      fromEmployeeContract.FEATURE_NAME,
      employeeContractService,
      employeeContractActions,
      actions$
    )
  }
}
